export default __webpack_public_path__ + "static/iam_role_07-cc79d50042f1a33399b1f4e54d2f1f0d.png";